import { Helmet } from 'react-helmet-async';

export default function QuizPage() {
  return (
    <div className="min-h-screen bg-[#06070B]">
      <Helmet>
        <title>The Contract of Ascension | Gnostic Quiz | MGN1.6</title>
        <meta name="description" content="Interactive video quiz on the Gnostic / Contracted Descent framework. Discover your stage of awareness through reflective questions." />
        <meta property="og:title" content="The Contract of Ascension | Gnostic Quiz" />
        <meta property="og:description" content="Interactive video quiz exploring awareness, acceptance, manifestation, and recall." />
        <meta property="og:type" content="website" />
      </Helmet>
      
      <div style={{ position: 'relative', width: '100%', maxWidth: '520px', margin: '0 auto', paddingTop: '20px' }}>
        <iframe
          src="https://gnostic-quiz.emergent.host"
          title="The Contract of Ascension"
          style={{ width: '100%', height: '844px', border: 0, borderRadius: '16px', background: '#06070B' }}
          allow="autoplay; fullscreen; clipboard-write; web-share"
          loading="lazy"
        />
      </div>
    </div>
  );
}
